import { Pipe, PipeTransform } from '@angular/core';
import { ERequestStatusCryptoTextType, ERequestStatusCryptoType } from '@app/views/pages/deposit/history/digital-currency-crypto/types/crypto-request-status.type';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'requestStatusTextCrypto',
	standalone: true
})
export class RequestStatusTextCryptoPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	RequestStatus = ERequestStatusCryptoTextType;
	translatedText: string;

	transform(value: ERequestStatusCryptoTextType): any {
		this.getTranslate(
			this.RequestStatus.getTitle(value)
		);

		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.REQUEST_STATUS_CRYPTO.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}

